import { CustomValuePillProps } from "PFComponents/custom_value_pill/custom_value_pill";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

type StateTooltipContentProps = Pick<CustomValuePillProps, "isPendingApproval">;

export const StateTooltipContent = ({ isPendingApproval }: StateTooltipContentProps) => {
  const { t } = useTranslation("core", { keyPrefix: "customValue" });

  if (isPendingApproval) {
    return <Typography variant="labelBold">{t("pendingApproval")}</Typography>;
  }

  return null;
};
